// based on rc-trigger 2.6.2
import Trigger from './Trigger'
export default Trigger



// WEBPACK FOOTER //
// ./components/vc-trigger/index.js